module.exports = __webpack_public_path__ + "static/media/main.fc3e2b2e.png";